import { useAuth0 } from '@auth0/auth0-react';

/**
 * True once Auth0 has finished restoring the session AND the user is logged in.
 *
 * The app-wide providers in `_app.tsx` (push, job events, app messages) mount ABOVE the router's
 * auth guard, so they also run for a visitor whose session is still being restored, or who is not
 * logged in at all. Firing an authenticated call there sends a request with no bearer, gets a 401
 * back — by which time Auth0 may have finished, so the 401 is mistaken for an expired token and
 * triggers a pointless refresh. Gate any mount-time authenticated call on this.
 * (Sentry RINGIL-APP-WM.)
 */
export const useAuthReady = (): boolean => {
  const { isAuthenticated, isLoading } = useAuth0();
  return isAuthenticated && !isLoading;
};
